import * as React from "react";
export class MbnIcon extends React.PureComponent {
    render() {
        const compPrefix = this.props.componentPrefix ? `${this.props.componentPrefix}-` : "";
        return (React.createElement("div", { className: `rj-ev-list__${compPrefix}icon rj-ev-list__${compPrefix}icon--mbn rj-ev-list__${compPrefix}icon--mbn--${this.props.tagNumber}`, "data-uat": `div-ev-list-${compPrefix}icon` },
            React.createElement("span", { className: `rj-ev-list__${compPrefix}icon-text` }, this.props.tagNumber)));
    }
}
//# sourceMappingURL=MbnIcon.js.map